const overflowingColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model'
  },
  {
    zh: '平均电流(A)',
    en: 'Average Current(A)',
    dataIndex: 'avgCurrent',
    key: 'avgCurrent'
  },
  {
    zh: '额定电流(A)',
    en: 'Rated Current(A)',
    dataIndex: 'ratedCurrent',
    key: 'ratedCurrent'
  },
  {
    zh: '过流率',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage',
    fixed: 2
  }
]

export {
  overflowingColumns
}
